import styled from 'styled-components';

import { addWindow } from 'store/slice/pdpStateSlice';
import { hideScrollbars } from 'styles/utils/hideScrollbars';
import { IProductSearch } from 'shared/types/ProductSearch';
import { Loader } from 'shared/components/Loader';
import { StandardVariantGridItem } from 'productTemplate/components/buyBar/StandardVariantGridItem';
import { useStoreDispatch } from 'store/hooks/storeHooks';
import { variableFontRegular } from 'styles/theme/text';

export interface IWindowItemVariantGridProps {
  data: IProductSearch[];
  isLoading: boolean;
  description?: string;
}

export const WindowItemVariantGrid = ({
  data,
  isLoading,
  description,
}: IWindowItemVariantGridProps) => {
  const storeDispatch = useStoreDispatch();

  const handleVariantClick = (variant) => {
    storeDispatch(addWindow(variant));
  };

  if (isLoading) return <Loader style={{ width: '264px' }} />;

  return (
    <WindowItemVariantGrid.Wrapper>
      {description && <WindowItemVariantGrid.Title>{description}</WindowItemVariantGrid.Title>}
      <WindowItemVariantGrid.Grid>
        {data.map((variant) => (
          <StandardVariantGridItem
            key={variant?.id}
            productSearch={variant}
            onClick={handleVariantClick}
          />
        ))}
      </WindowItemVariantGrid.Grid>
    </WindowItemVariantGrid.Wrapper>
  );
};

WindowItemVariantGrid.Wrapper = styled.div``;

WindowItemVariantGrid.Grid = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  column-gap: 8px;
  row-gap: 16px;
  max-height: 329px;
  min-width: 264px;
  overflow-y: scroll;
  width: 100%;
  max-width: 332px;

  ${hideScrollbars}
`;

WindowItemVariantGrid.Title = styled.div`
  ${variableFontRegular({ size: '9.5px', height: '11px' })};
  text-transform: none;
  margin-bottom: 16px;
`;
